import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import Button from 'react-toolbox/lib/button';
import { Card, CardTitle, CardText } from 'react-toolbox/lib/card';
import ButtonLink from '../ButtonLink';

const CustomCardTitle = glamorous(CardTitle, {
  rootEl: 'div',
  forwardProps: ['avatar', 'children', 'className', 'subtitle', 'title'],
})({
  '& > div': { margin: '0 auto' },
  '& h5': { fontSize: '4.0rem !important', textAlign: 'center' },
});

const CustomCardText = glamorous(CardText, {
  rootEl: 'div',
  forwardProps: ['children', 'className'],
})({
  textAlign: 'center',
});

const renderRedirectButton = (redirectMessage, redirectData) => {
  const buttonProps = {
    raised: true,
    accent: true,
    label: redirectMessage,
  };
  switch (typeof redirectData) {
    case 'string':
      return <ButtonLink to={redirectData} {...buttonProps} />;

    case 'function':
      return <Button onClick={redirectData} {...buttonProps} />;

    default:
      return null;
  }
};

const NoMatch = ({
  title,
  subtitle,
  handleRedirect,
  reactRouterLocation,
  redirectMessage,
}) => (
  <Card>
    {title || subtitle
      ? <CustomCardTitle title={title || ''} subtitle={subtitle || ''} />
      : null}
    {redirectMessage && (reactRouterLocation || handleRedirect)
      ? <CustomCardText>
          {/* Prefer react router redirect, only use handler if not provided */}
          {renderRedirectButton(
            redirectMessage,
            reactRouterLocation || handleRedirect
          )}
        </CustomCardText>
      : null}
  </Card>
);

NoMatch.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  handleRedirect: PropTypes.func,
  redirectMessage: PropTypes.string,
  reactRouterLocation: PropTypes.string,
};

export default NoMatch;



// WEBPACK FOOTER //
// ./src/common/components/NotFound/index.js